import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Event } from "JS/Models/Events";

export interface EventState {
    eventsList?: Event[];
    eventCalledByName?: {
        isEventCalled: boolean;
        eventFolderName: string;
    };
}

const initialState: EventState = {
    eventsList: [],
    eventCalledByName: { isEventCalled: false, eventFolderName: "" },
};

export const eventStateSlice = createSlice({
    name: "eventState",
    initialState,
    reducers: {
        setGlobalEvents: (state, data: PayloadAction<EventState>) => {
            state.eventsList = data.payload.eventsList;
            return state;
        },
        setIsEventCalledByName: (
            state,
            action: PayloadAction<{
                isEventCalled: boolean;
                eventFolderName?: string;
            }>,
        ) => {
            state.eventCalledByName = {
                isEventCalled: action.payload.isEventCalled,
                eventFolderName: action.payload.eventFolderName || "",
            };
            return state;
        },

        resetEventsState: () => {
            return initialState;
        },
    },
});
export const { setGlobalEvents, setIsEventCalledByName, resetEventsState } =
    eventStateSlice.actions;
